import * as _ from 'lodash';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { fromEvent, of, Subject } from 'rxjs';
import { concatMap, debounceTime, filter, map, take, takeUntil } from 'rxjs/operators';
import { CampaignService } from 'app/campaign/services/campaign.service';
import { InPersonEventSchema } from '../../schemas/in-person-event';
import { ImageService } from 'app/core/services/image.service';
import { DomSanitizer } from '@angular/platform-browser';
import {
  addEventPageBlock,
  clearSelectedEvent,
  createEvent, createEventSuccess,
  loadEventListAndSelect,
  //  loadEventConfig,
  putEvent,
  updateEventConfigPage, updateEventPageBlock
} from '../../features/event.actions';
import { selectEventSelected } from '../../features/event.selectors';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { loadEventCampaignList } from 'app/campaign/features/campaign.actions';
import { SharedService } from 'app/virtual-event/services/shared.service';
import {
  selectEventPageCampaignList,
  selectCampaignList,
  selectLiveAuctionCampaignList,
  selectSilentAuctionCampaignList
} from 'app/campaign/features/campaign.selectors';
import {
  ConfigurationSchema,
  DonationCampaignPartSchema,
  EventConfigSchema,
  FaqPartSchema, LiveAuctionCampaignPartSchema, SilentAuctionCampaignPartSchema,
  SlidesPartSchema, SponsorSchema,
  TextPartSchema, VideoContainerPartSchema, ImagePartSchema
} from '../../schemas/virtual-event';
import { SlideSchema } from '../../../virtual-event/structure/virtual-event';
import { EventPageBlockTypeService } from '../../services/event-page-block-type.service';
import { TimeZoneService } from '../../services/time-zone.service';
import * as moment from 'moment-timezone';
import { ArrayValidators } from '../../validators/array.validators';
import { ToastService } from '../../../toast/services/toast.service';
import { Actions, ofType } from '@ngrx/effects';
import { MdbTabChange } from 'mdb-angular-ui-kit/tabs/tabs.component';
import { VideoProviderService } from '../../services/video-provider.service';
import { MdbTabsComponent } from 'mdb-angular-ui-kit/tabs';
import { EventTabsService } from '../../services/event-tabs.service';
import { QuillEditorComponent } from 'ngx-quill';
import { Router } from '@angular/router';
import { QuillService } from 'app/core/services/quill.service';
import { ChooseImageModalService } from 'app/core/services/choose-image-modal.service';

@Component({
  selector: 'app-in-person-event',
  templateUrl: './in-person-event.component.html',
  styleUrls: ['./in-person-event.component.scss']
})
export class InPersonEventComponent implements OnInit, OnDestroy {

  @ViewChild('inPersonEventDescrQuill') quillInPersonEventDescription: QuillEditorComponent = null;

  @ViewChild('tabs')
  set tabs(tabs: MdbTabsComponent) {
    this.tabsService.tabs = tabs;
  };
  get tabs(): MdbTabsComponent {
    return this.tabsService.tabs;
  }

  @Input()
  public id: string = null;

  public event: any = null;

  public selectedEvent = this.store.pipe(select(selectEventSelected));
  public campaigns$ = this.store.pipe(
    select(selectCampaignList),
    map(list => {
      return this.getTicketingCampaignList(list);
    })
  );

  public form: UntypedFormGroup = new UntypedFormGroup({});
  public submitted: boolean = false;
  public disableTypeSelect = false;
  public campaignTypeData: UntypedFormGroup = null;
  public eventVenue: UntypedFormGroup = null;
  public saveAndExit: boolean = false;

  public accordion = {
    eventPaddles: { expanded: false },
    tableAssignment: { expanded: false },
    golfPack: { expanded: false },
    ticketing: { expanded: false },
    coverFee: { expanded: false }
  }

  public takeUntilSubject: Subject<any> = new Subject();
  public eventPageSlide: UntypedFormGroup = null;
  public eventConfiguration: UntypedFormGroup = null;
  public videoContainerPart: UntypedFormGroup = null;
  public videoProviderSelected: number = 0;

  public prevStep:number = 0;

  // Event page parts
  public removeFromNav: FormGroup = null;
  public textPart: FormGroup = null;
  public faqPart: FormGroup = null;
  public slidesPart: FormGroup = null;
  public slidesPartBulkImport: FormControl = null;
  public imagesQueue: any[] = [];
  public config: FormGroup = null;
  public eventConfigData: any = null;

  public donationCampaignPart: UntypedFormGroup = null;
  public silentAuctionCampaignPart: UntypedFormGroup = null;
  public liveAuctionCampaignPart: UntypedFormGroup = null;
  public inPersonEventSponsor: UntypedFormGroup = null;
  public sponsorSubmitted: boolean = false;
  public imagePart: UntypedFormGroup = null;
  public eventImageSelected: boolean = false;

  public sponsorMode: string = 'list';
  public configMode: string = 'list';
  public eventPageSlideMode: string = 'list';
  public EPSlideSubmitted: boolean = false;
  public selectedPageType = 1;
  public currentSponsorIndex = null;
  public eventPageId!: string;
  setActiveTab: any;

  public quillInPersonEventInstanse:any = null;
  public inPersonEventDescription:any = null;
  public inPersonEventSettedContent:any = null;

  public quillTextBlockInstanse:any = null;
  public textBlockDescription:any = null;
  public textBlockSettedContent:any = null;

  public quillVideoDescInstanse:any = null;
  public videoDescription:any = null;
  public videoSettedContent:any = null;

  public modules = {
    clipboard: true,
    toolbar: [['bold', 'italic', 'underline','link'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }]]
  };

  public quillDescLength:any = 1;
  public quillTextBlockLength:any = 1;
  public quillVideoContainerDescLength:any = 1;

  onTabChange(event: MdbTabChange):void {
    let isFormValid = true;

    if (event.index === 1) {
      isFormValid = this.onValidate();
    }
    if (event.index === 2) {
      isFormValid = this.onCheckAndSaveCampaign();
    }

    this.tabsService.onTabChange(event, isFormValid);
  }

  public themeConfigurationScreen: boolean = false;


  public donationCampaigns$: any = this.store.pipe(
    select(selectEventPageCampaignList),
    map(list => {
      return _.filter(list, {status: 0});
    })
  );

  public silentAuctions$: any = this.store.pipe(
    select(selectSilentAuctionCampaignList),
    map(list => {
      return _.filter(list, {status: 0});
    })
  );

  public liveAuctions$: any = this.store.pipe(
    select(selectLiveAuctionCampaignList),
    map(list => {
      return _.filter(list, {status: 0});
    })
  );

  // public loadEventConfig$ = this.store.pipe(
  //   select(selectEventConfig)
  // );

  public step: number = 0;
  constructor(
    public router: Router,
    public store: Store,
    public campaignService: CampaignService,
    public imageService: ImageService,
    public domSanitizer: DomSanitizer,
    public sharedService: SharedService,
    public element: ElementRef,
    public eventPageBlockTypeService: EventPageBlockTypeService,
    public fb: UntypedFormBuilder,
    public timeZoneService: TimeZoneService,
    public toastService: ToastService,
    public updates$: Actions,
    public videoProviderService: VideoProviderService,
    public tabsService: EventTabsService,
    public quillService:QuillService,
    private chooseImageModalService: ChooseImageModalService,
  ) {
    this.tabsService.lastStep = 2;
  }

  ngOnInit(): void {
    this.campaignService.generateForm(this.form, InPersonEventSchema);
 
    if (this.id) {
      this.store.dispatch({
        type: loadEventListAndSelect.type,
        payload: this.id
      });
      //this.eventPageId = this.payload.inPersonEventInfo.eventPageId;
    }

    this.store.dispatch({
      type: loadEventCampaignList.type,
      payload: this.sharedService.token
    });

    const timestamp = this.form.get('startDateTimeGmtUnix').value * 1000;
    this.timeZoneService.updateTimeZoneList(timestamp === 0 ? moment().unix() * 1000 : timestamp);

    this.eventPageSlide = this.fb.group({});
    this.eventConfiguration = this.fb.group({});
    this.inPersonEventSponsor = this.fb.group({});

    this.config = this.fb.group({});
    this.textPart = this.fb.group({});
    this.faqPart = this.fb.group({
      options: new UntypedFormArray([], ArrayValidators.minLength(1))
    });

    this.slidesPart = this.fb.group({
      slides: new UntypedFormArray([], ArrayValidators.minLength(1))
    });

    this.slidesPartBulkImport = new FormControl([]);

    this.donationCampaignPart = this.fb.group({});
    this.silentAuctionCampaignPart = this.fb.group({});
    this.liveAuctionCampaignPart = this.fb.group({});
    this.videoContainerPart = this.fb.group({});
    this.imagePart = this.fb.group({});


    this.campaignService.generateForm(this.eventPageSlide, SlideSchema);
    this.campaignService.generateForm(this.inPersonEventSponsor, SponsorSchema);
    this.campaignService.generateForm(this.eventConfiguration, EventConfigSchema);

    this.campaignService.generateForm(this.config, ConfigurationSchema);
    this.campaignService.generateForm(this.textPart, TextPartSchema);
    this.campaignService.generateForm(this.faqPart, FaqPartSchema);
    this.campaignService.generateForm(this.slidesPart, SlidesPartSchema);
    this.campaignService.generateForm(this.videoContainerPart, VideoContainerPartSchema);
    this.campaignService.generateForm(this.imagePart, ImagePartSchema);

    this.campaignService.generateForm(this.donationCampaignPart, DonationCampaignPartSchema);
    this.campaignService.generateForm(this.silentAuctionCampaignPart, SilentAuctionCampaignPartSchema);
    this.campaignService.generateForm(this.liveAuctionCampaignPart, LiveAuctionCampaignPartSchema);

    this.eventConfiguration.controls.eventPageBlockType.setValue(4)
    this.imageService.initializeImageControl('event-page-slide-image', this.eventPageSlide, this.takeUntilSubject);
    this.imageService.initializeImageControl('in-person-event-page-image', this.imagePart, this.takeUntilSubject);

    this.selectedEvent.pipe(
      filter(event => {
        const id = _.get(event, 'inPersonEventInfo.id', null);
        return !_.isNull(id)
      }),
      takeUntil(this.takeUntilSubject)
    ).subscribe((event) => {
      this.event = event;
      this.eventPageId = event.inPersonEventInfo.eventPageId;
    });

    this.selectedEvent.pipe(
      filter(event => {
        const id = _.get(event, 'inPersonEventInfo.id', null);
        return !_.isNull(id)
      }),
      map(event => {
        return event.inPersonEventInfo;
      }),
      takeUntil(this.takeUntilSubject)
    ).subscribe((event: any) => {
      this.resetEvent(this.form);
      this.campaignService.initializeForm(this.form, event, InPersonEventSchema);
      const timestamp = event.startDateTimeGmtUnix * 1000;
      this.timeZoneService.updateTimeZoneList(timestamp === 0 ? moment().unix() * 1000 : timestamp);
    });

    const timeZoneData = this.form.get('timeZoneData');
    timeZoneData.get('name').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const zone = moment.tz.zone(value);
      const abbrControl = timeZoneData.get('abbr');

      const timestamp = this.form.get('startDateTimeGmtUnix').value * 1000;
      const abbr = zone.abbr(timestamp);

      abbrControl.setValue(abbr);
    });

    timeZoneData.get('abbr').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(abbr => {
      const abbrControl = timeZoneData.get('abbr');
      const nameControl = timeZoneData.get('name');
      const offsetControl = timeZoneData.get('offset');

      const zone = moment.tz.zone(nameControl.value);

      const index = _.findIndex(zone.abbrs, value => _.isEqual(value, abbr));
      const offset = zone.offsets[index] * -60;

      offsetControl.setValue(offset);

      const matches = abbr.match(/[\+\-][0-9]+/);
      const abbrValue = _.isArray(matches) ? `GMT ${matches[0]}` : abbr;

      this.form.get('timeZoneAbbr').setValue(abbrValue);
      this.form.get('timeZone').setValue(offset);

      abbrControl.setValue(abbrValue, {emitEvent: false});
    });

    this.form.get('startDateTimeGmtUnix').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      filter(() => {
        const nameControl = timeZoneData.get('name');
        return !_.isNull(nameControl.value)
      }),
      filter(() => {
        const abbrControl = timeZoneData.get('abbr');
        return !_.isNull(abbrControl.value)
      }),
      map(value => value * 1000),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const nameControl = timeZoneData.get('name');
      const abbrControl = timeZoneData.get('abbr');
      const zone = moment.tz.zone(nameControl.value);
      const abbr = zone.abbr(value);
      abbrControl.setValue(abbr);

      const timestamp = this.form.get('startDateTimeGmtUnix').value * 1000;
      this.timeZoneService.updateTimeZoneList(timestamp === 0 ? moment().unix() * 1000 : timestamp);
    });

    this.form.get('imageFile').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const windowURL = window.URL || window.webkitURL;
      const url = windowURL.createObjectURL(value);
      this.imageService.cropper({
        url: this.domSanitizer.bypassSecurityTrustUrl(url),
        id: 'in-person-event-image',
        name: value.name,
        type: value.type,
      });
    });

    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === 'in-person-event-image'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      this.form.get('imageDataUrl').setValue(result);
    });

    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === 'in-person-event-image'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      if(result === false) {
        this.resetImage();
      } else {
        this.form.get('image').setValue(result.imageUrl);
      }
    });

    this.form.get('paddleRequired').valueChanges.pipe(
      filter(value => !value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const paddleMinNum = this.form.get('paddleMinNum');

      const paddleMinNumValidators = [Validators.required, Validators.min(0)];

      paddleMinNum.clearValidators();
      paddleMinNum.setValidators(paddleMinNumValidators);
      paddleMinNum.setValue(0);
      paddleMinNum.updateValueAndValidity({ emitEvent: false });
    });

    this.form.get('paddleRequired').valueChanges.pipe(
      filter(value => value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      const paddleMinNum = this.form.get('paddleMinNum');
      const emptyPaddleCount = this.form.get('emptyPaddleCount');

      paddleMinNum.clearValidators();
      paddleMinNum.setValidators([Validators.required, Validators.min(1)])
      paddleMinNum.setValue(101);
      paddleMinNum.updateValueAndValidity({ emitEvent: true });

      emptyPaddleCount.clearValidators();
      emptyPaddleCount.setValidators([Validators.required, Validators.min(1)]);
      emptyPaddleCount.setValue(10);
      emptyPaddleCount.updateValueAndValidity({ emitEvent: true });
    });

    this.form.get('paddleMinNum').valueChanges.pipe(
      map(value => {
        const paddleRequired = this.form.get('paddleRequired');
        const defaultValue = paddleRequired.value ? 1: 0;
        return value < 1 ? defaultValue: value;
      }),
      takeUntil(this.takeUntilSubject)
    );

    this.eventVenue = this.form.get('eventVenue') as UntypedFormGroup;
    this.imageService.initializeImageControl('in-person-event-sponsor-image', this.inPersonEventSponsor, this.takeUntilSubject);

    this.updates$.pipe(
      ofType(
        createEventSuccess.type
      ),
      takeUntil(this.takeUntilSubject)
    ).subscribe((action: {data: any, type: string}) => {
        if (action.data && !this.saveAndExit) {
          if (!this.event) {
            this.event = {};
            this.event.inPersonEventInfo = action.data;
          }

          this.id = action.data.id;
          this.eventPageId = action.data.eventPageId;
          this.campaignService.initializeForm(this.form, action.data, InPersonEventSchema);
        }

        this.saveAndExit = false;
      });

      this.slidesPartBulkImport.valueChanges.pipe(
        filter(value => !_.isNull(value)),
        takeUntil(this.takeUntilSubject)
      ).subscribe(value => {
        const id = 'slide-images';
        if (value && value.length) {
          this.imagesQueue = value;
          this.uploadImages(id);
  
        } else {
          const windowURL = window.URL || window.webkitURL;
          const url = windowURL.createObjectURL(value);
          this.imageService.cropper({
            url: this.domSanitizer.bypassSecurityTrustUrl(url),
            id,
            name: value.name,
            type: value.type,
          });
        }
      });

      this.inPersonEventDescription = this.form.get('desc')
      this.textBlockDescription = this.textPart.get('textBlock')
      this.videoDescription = this.videoContainerPart.get('videoContainerDesc')
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
    this.tabsService.reset();
    this.resetFormBlocks();
    this.saveAndExit = false;

    this.store.dispatch({
      type: clearSelectedEvent.type
    });
  }

  onCancel(): void {
    this.router.navigateByUrl('/event/list');
  }

  onSave(): void {
    const valid = this.onValidate();
    if(valid === false) return;

    this.saveAndExit = true;

    const requestObject = this.campaignService.generateRequestObject(this.form, InPersonEventSchema);
    this.store.dispatch({
      type: this.id ? putEvent.type: createEvent.type,
      payload: requestObject,
      redirect: true
    });
  }

  onManageTables() {
    window['orgMain'].manageEventTable(this.id, function(value) { })
  }
  onValidate(): boolean {
    this.submitted = true;

    if (this.form.valid) {
      return true;
    }
    this.form.markAllAsTouched();

    const firstInvalidControl: HTMLElement = this.element.nativeElement.querySelector(".ng-invalid");
    const panel = _.get(firstInvalidControl.dataset, 'panel', null);
    if(!_.isNull(panel)) {
      _.set(this.accordion, `${panel}.expanded`, true);
    }


    setTimeout(()=>{
      window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
    },500)

    fromEvent(window, "scroll").pipe(
      debounceTime(100),
      take(1),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => firstInvalidControl.focus());

    return false;
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  resetEvent(formGroup) {
    _.forEach(formGroup.controls, (control, key) => {
      if(control instanceof UntypedFormGroup) {
        this.resetEvent(control);
      } else if(control instanceof UntypedFormArray) {
        while (control.length !== 0) {
          control.removeAt(0)
        }
      } else if(control instanceof UntypedFormControl) {
        switch(key) {
          case 'inviteMessage':
          case 'confirmMessage':
            control.reset('');
            break;
          default:
            control.reset();
        }
      }
    });
  }

  getTicketingCampaignList(campaigns) {
    var list = []
    campaigns.forEach(function(campaign) {
      var ticketingTypeData = campaign.campaignTypeData
      if(campaign.type == CAMPAIGN_TYPE.TICKETING
        && campaign.status == 0
        && ticketingTypeData.guestRequired
        && (ticketingTypeData.linkedEventId == undefined ||
          ticketingTypeData.linkedEventId == "" ||
          ticketingTypeData.linkedEventId == null
        )
      ) {
        list.push(campaign)
      }
    });
    return list;
  }

  moveToEventPageList(mode) {
    this.configMode = mode;
    return;
  }

  updateSection(data) {
    this.eventConfigData = data.payload.eventConfigData;

    if (data.payload.index || data.payload.index === 0) {
      const section = this.eventConfigData.pageBlocks[data.payload.index];

      switch (section.type) {
        case 1:
          // text
          this.textPart.reset({
            removeFromNav: section.removeFromNav,
            textBlock: section.text,
            type: 1,
            textBlockTitle: section.blockTitle,
            id: section.id
          });

          break;
        case 2:
          // FAQ
          const faqArr = this.fb.array(section.faq.map(faq => {
            return this.fb.group({
              question: new UntypedFormControl(faq.question, []),
              answer: new UntypedFormControl(faq.answer, [])
            });
          }));

          this.faqPart.reset({
            removeFromNav: section.removeFromNav,
            options:  faqArr,
            type: 2,
            faqBlockTitle: section.blockTitle,
            id: section.id
          });
          this.faqPart.setControl('options', faqArr);

          break;
        case 3:
          // slides
          const slides = this.fb.array(section.slides.map(slide => {
            return this.fb.group({
              imageUrl: new UntypedFormControl(slide.imageUrl, [Validators.required]),
              name: new UntypedFormControl(slide.name, [Validators.maxLength(512)])
            });
          }));

          this.slidesPart.reset({
            removeFromNav: section.removeFromNav,
            slides,
            type: 3,
            slidesBlockTitle: section.blockTitle,
            id: section.id
          });
          this.slidesPart.setControl('slides', slides);
          break;
        case 4:
          // donation campaign
          this.donationCampaignPart.reset({
            removeFromNav: section.removeFromNav,
            campaignId: section.campaignId,
            type: 4,
            title: section.blockTitle,
            id: section.id
          });
          break;
        case 5:
          // silent auction
          this.silentAuctionCampaignPart.reset({
            removeFromNav: section.removeFromNav,
            campaignId: section.campaignId,
            type: 5,
            title: section.blockTitle,
            id: section.id
          });
          break;
        case 6:
          // live auction
          this.liveAuctionCampaignPart.reset({
            removeFromNav: section.removeFromNav,
            campaignId: section.campaignId,
            type: 6,
            title: section.blockTitle,
            id: section.id
          });
          break;
        case 7:
          // video container
          this.videoContainerPart.reset({
            removeFromNav: section.removeFromNav,
            videoProvider: section.videoData.provider,
            videoContainerDesc: section.videoData.desc,
            type: 7,
            videoContainerTitle: section.blockTitle,
            videoContainerUrl: section.videoData.url,
            id: section.id
          });

          break;    
        case 8: 
          //image
          this.imagePart.reset({
            removeFromNav: section.removeFromNav,
            iamgeDataUrl: section.imageUrl,
            imageUrl: section.imageUrl,
            imageBlockTitle: section.blockTitle,
            imageBlockText: section.text,
            type: 8,
            id: section.id
          })

          const imageUrl = this.imagePart.get('imageUrl').value === '/images/org_logo_default_v2.svg' ?
          '/images/blank_2x1.png':
          this.imagePart.get('imageUrl').value;
          this.imagePart.get('imageDataUrl').setValue(imageUrl);
          this.imagePart.get('imageUrl').setValue(imageUrl);
          
          if(this.imagePart.value.imageDataUrl != '/images/blank_2x1.png' && this.imagePart.value.imageUrl != '/images/blank_2x1.png') {
            this.eventImageSelected = true;
          } else {
            this.eventImageSelected = false;
            this.imagePart.markAllAsTouched();
            return
          }

          break;
      }

      this.disableTypeSelect = true;
      this.selectedPageType = section.type;
      this.eventConfiguration.controls.eventPageBlockType.setValue(section.type);
      this.configMode = data.mode;
      return;
    }
  }

  addSection(data) {
    this.disableTypeSelect = false;
    this.resetEvent(this.eventConfiguration);
    this.campaignService.initializeForm(this.eventConfiguration, {}, EventConfigSchema);
    this.configMode = data.mode;
    this.resetFormBlocks();
  }

  changeEventConfigMode(data) {
    if (data.payload.index || data.payload.index === 0) {
      this.updateSection(data);
      return;
    }
    this.addSection(data);
  }

  updateEventPage(payload) {
    if (this.id) {
      this.store.dispatch({
        type: updateEventConfigPage.type,
        payload
      });
    }
  }

  onSaveEventPageBlock() {
    let payload;
    let formArray;
    const form = this.fb.group({});
    
    switch (this.eventConfiguration.controls.eventPageBlockType.value) {
      case 1:
        payload = {
          eventPageId: this.event.inPersonEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.textPart.value.removeFromNav,
            type: 1,
            blockTitle: this.textPart.value.textBlockTitle,
            text: this.textPart.value.textBlock
          }
        };

        if (this.textPart.value.id) {
          payload.eventPageBlock.id = this.textPart.value.id;
        }

        if (this.textPart.invalid) {
          this.textPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, TextPartSchema);
        this.campaignService.initializeForm(form, this.textPart.value, TextPartSchema);

        formArray = this.config.get('textPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 2:
        payload = {
          eventPageId: this.event.inPersonEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.faqPart.value.removeFromNav,
            type: 2,
            faq: this.faqPart.value.options,
            blockTitle: this.faqPart.value.faqBlockTitle
          }
        };

        if (this.faqPart.value.id) {
          payload.eventPageBlock.id = this.faqPart.value.id;
        }

        if (this.faqPart.invalid) {
          this.faqPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, FaqPartSchema);
        this.campaignService.initializeForm(form, this.faqPart.value, FaqPartSchema);

        formArray = this.config.get('faqPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 3:
        payload = {
          eventPageId: this.event.inPersonEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.slidesPart.value.removeFromNav,
            type: 3,
            slides: this.slidesPart.value.slides,
            blockTitle: this.slidesPart.value.slidesBlockTitle
          }
        };

        if (this.slidesPart.value.id) {
          payload.eventPageBlock.id = this.slidesPart.value.id;
        }

        if (this.slidesPart.invalid) {
          this.slidesPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, SlidesPartSchema);
        this.campaignService.initializeForm(form, this.slidesPart.value, SlidesPartSchema);

        formArray = this.config.get('slidesPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 4:
        payload = {
          eventPageId: this.event.inPersonEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.donationCampaignPart.value.removeFromNav,
            type: 4,
            campaignId: this.donationCampaignPart.value.campaignId,
            blockTitle: this.donationCampaignPart.value.title
          }
        };

        if (this.donationCampaignPart.value.id) {
          payload.eventPageBlock.id = this.donationCampaignPart.value.id;
        }

        if (this.donationCampaignPart.invalid) {
          this.donationCampaignPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, DonationCampaignPartSchema);
        this.campaignService.initializeForm(form, this.donationCampaignPart.value, DonationCampaignPartSchema);

        formArray = this.config.get('donationCampaignPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 5:
        payload = {
          eventPageId: this.event.inPersonEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.silentAuctionCampaignPart.value.removeFromNav,
            type: 5,
            campaignId: this.silentAuctionCampaignPart.value.campaignId,
            blockTitle: this.silentAuctionCampaignPart.value.title
          }
        };

        if (this.silentAuctionCampaignPart.value.id) {
          payload.eventPageBlock.id = this.silentAuctionCampaignPart.value.id;
        }

        if (this.silentAuctionCampaignPart.value.id) {
          payload.eventPageBlock.id = this.silentAuctionCampaignPart.value.id;
        }

        this.campaignService.generateForm(form, SilentAuctionCampaignPartSchema);
        this.campaignService.initializeForm(form, this.silentAuctionCampaignPart.value, SilentAuctionCampaignPartSchema);

        formArray = this.config.get('silentAuctionCampaignPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 6:
        payload = {
          eventPageId: this.event.inPersonEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.liveAuctionCampaignPart.value.removeFromNav,
            type: 6,
            campaignId: this.liveAuctionCampaignPart.value.campaignId,
            blockTitle: this.liveAuctionCampaignPart.value.title
          }
        };

        if (this.liveAuctionCampaignPart.value.id) {
          payload.eventPageBlock.id = this.liveAuctionCampaignPart.value.id;
        }

        if (this.liveAuctionCampaignPart.invalid) {
          this.liveAuctionCampaignPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, LiveAuctionCampaignPartSchema);
        this.campaignService.initializeForm(form, this.liveAuctionCampaignPart.value, LiveAuctionCampaignPartSchema);

        formArray = this.config.get('liveAuctionCampaignPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 7:
        payload = {
          eventPageId: this.event.inPersonEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.videoContainerPart.value.removeFromNav,
            type: 7,
            blockTitle: this.videoContainerPart.value.videoContainerTitle,
            videoData: {
              desc: this.videoContainerPart.value.videoContainerDesc,
              url: this.videoContainerPart.value.videoContainerUrl,
              provider: this.videoContainerPart.value.videoProvider
            }
          }
        };

        if (this.videoContainerPart.value.id) {
          payload.eventPageBlock.id = this.videoContainerPart.value.id;
        }

        if (this.videoContainerPart.invalid) {
          this.videoContainerPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, VideoContainerPartSchema);
        this.campaignService.initializeForm(form, this.videoContainerPart.value, VideoContainerPartSchema);

        formArray = this.config.get('videoContainerPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 8:
        payload = {
          eventPageId: this.event.inPersonEventInfo.eventPageId,
          eventPageBlock: {
            type: 8,
            imageUrl: this.imagePart.value.imageUrl,
            blockTitle: this.imagePart.value.imageBlockTitle,
            text: this.imagePart.value.imageBlockText,
            removeFromNav:this.imagePart.value.removeFromNav
          }
        }

        if (this.imagePart.value.id) {
          payload.eventPageBlock.id = this.imagePart.value.id;
        }

        if (this.imagePart.invalid) {
          this.imagePart.markAllAsTouched();
          return;
        }

        if(this.imagePart.value.imageDataUrl != '/images/blank_2x1.png' && this.imagePart.value.imageUrl != '/images/blank_2x1.png') {
          this.eventImageSelected = true;
        } else {
          this.eventImageSelected = false;
          this.imagePart.markAllAsTouched();
          return
        }

        this.campaignService.generateForm(form, ImagePartSchema);
        this.campaignService.initializeForm(form, this.imagePart.value, ImagePartSchema);

        formArray = this.config.get('imagePart') as UntypedFormArray;
        formArray.push(form);

        break;
    }

    const valid = this.campaignService.isFormValid(form, []);
    if (!valid) {
      form.markAllAsTouched();
      return;
    }

    if (payload.eventPageBlock.id) {
      this.store.dispatch({
        type: updateEventPageBlock.type,
        payload
      });
    } else {
      this.store.dispatch({
        type: addEventPageBlock.type,
        payload
      });
    }

    this.changeEventConfigMode({
      payload: {eventConfigData: this.eventConfigData},
      mode: 'list'
    });
  }

  resetFormBlocks() {
    this.faqPart.reset({options: new UntypedFormArray([], ArrayValidators.minLength(1)), type: 'faq', faqBlockTitle: '', removeFromNav: false});
    this.textPart.reset({textBlock: '', type: 'text', textBlockTitle: '', removeFromNav: false});
    (this.slidesPart.get('slides') as UntypedFormArray).clear()
    this.slidesPart.reset({slides: new UntypedFormArray([], ArrayValidators.minLength(1)), type: 'slides', slidesBlockTitle: '', removeFromNav: false});
    this.videoContainerPart.reset({videoContainerTitle: '', videoContainerDesc: '', videoContainerUrl: '', type: 'video', videoProvider: 0, removeFromNav: false});
    this.donationCampaignPart.reset({campaignId: '', type: 'donationCampaign', title: '', removeFromNav: false});
    this.silentAuctionCampaignPart.reset({campaignId: '', type: 'silentAuction', title: '', removeFromNav: false});
    this.liveAuctionCampaignPart.reset({campaignId: '', type: 'liveAuction', title: '', removeFromNav: false});
    this.selectedPageType = 4;
    this.imagePart.reset({ 
      imageBlockText: '', 
      type: 'eventPageBlockTypeImage', 
      imageBlockTitle: '', 
      removeFromNav: false,
      imageFile: null,
      imageDataUrl: '/images/blank_2x1.png',
      imageUrl: '/images/blank_2x1.png',
    });
  }

  onChangeEventPageSlideMode(mode) {
    this.resetEvent(this.eventPageSlide);
    this.campaignService.initializeForm(this.eventPageSlide, {}, SlideSchema);
    this.eventPageSlideMode = mode;
    this.configMode = mode === 'editor' ? '' : 'eventConfig';
  }

  onSaveEPSlide() {
    this.EPSlideSubmitted = true;

    if (this.eventPageSlide.invalid) {
      this.eventPageSlide.markAllAsTouched();
      return;
    }
    if (this.eventPageSlide.controls.imageUrl.value === '/images/blank_2x1.png') {
      return;
    }

    const form = this.fb.group({});
    this.campaignService.generateForm(form, SlideSchema);
    this.campaignService.initializeForm(form, this.eventPageSlide.value, SlideSchema);

    const slides = this.slidesPart.get('slides') as UntypedFormArray;
    slides.push(form);

    this.onChangeEventPageSlideMode('list');
  }

  openChooseImageModal(type = 0, placeOfCall = null) { // 0 for 2x1, 1 for 1x1
    const params = {
      start: 0,
      returnCount: 40,
      filterBy:[type]
    }

    this.campaignService.getOrganizationImages(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((imageList: any)=> {
      const list = imageList || [];
      const images = list.filter((image) => image.type === type)
      const modalRef = this.chooseImageModalService.open({ images, type });
    
      modalRef.onClose.pipe(
        takeUntil(this.takeUntilSubject)
      ).subscribe((imageUrl) =>{
        if(imageUrl) {
          switch (placeOfCall) {
            case 'sponsor':
              this.inPersonEventSponsor.get(`imageDataUrl`).setValue(imageUrl);
              this.inPersonEventSponsor.get(`imageUrl`).setValue(imageUrl);
              break;
            case 'eventPageSlides':
              this.eventPageSlide.get(`imageDataUrl`).setValue(imageUrl);
              this.eventPageSlide.get(`imageUrl`).setValue(imageUrl);
              break;
            case 'imageSection':
              this.imagePart.get(`imageDataUrl`).setValue(imageUrl);
              this.imagePart.get(`imageUrl`).setValue(imageUrl);
              break;
            default:
              this.form.get(`imageDataUrl`).setValue(imageUrl);
              this.form.get(`image`).setValue(imageUrl);
              break;
          }
          
          this.toastService.show('success', 'Added Successfully!', {delay: 2000});
        }
        this.chooseImageModalService.modalRef = null;
      })
    })
  }

  resetImage() {
    this.form.get('imageFile').setValue(null);
    this.form.get('imageDataUrl').setValue('/images/blank_2x1.png');
    this.form.get('image').setValue('/images/blank_2x1.png');
  }

  resetSponsorImage() {
    this.inPersonEventSponsor.get('imageFile').setValue(null);
    this.inPersonEventSponsor.get('imageDataUrl').setValue('/images/blank_2x1.png');
    this.inPersonEventSponsor.get('imageUrl').setValue('/images/blank_2x1.png');
  }

  resetEventPageSlideImage() {
    this.eventPageSlide.get('imageFile').setValue(null);
    this.eventPageSlide.get('imageDataUrl').setValue('/images/blank_2x1.png');
    this.eventPageSlide.get('imageUrl').setValue('/images/blank_2x1.png');
  }

  resetImagePart() {
    this.imagePart.get('imageFile').setValue(null);
    this.imagePart.get('imageDataUrl').setValue('/images/blank_2x1.png');
    this.imagePart.get('imageUrl').setValue('/images/blank_2x1.png');
  }

  goToInPersonInfo() {
    this.step = 0;
  }

  onCheckAndSaveCampaign() {
    const valid = this.onValidate();

    if (valid === false) {
      return false;
    }

    const requestObject = this.campaignService.generateRequestObject(this.form, InPersonEventSchema);
    this.store.dispatch({
      type: this.id ? putEvent.type: createEvent.type,
      payload: requestObject,
      redirect: false
    });

    return true;
  }

  onChangeSponsorMode(mode) {
    this.resetEvent(this.inPersonEventSponsor);
    this.campaignService.initializeForm(this.inPersonEventSponsor, {}, SponsorSchema);
    this.sponsorMode = mode;
  }

  editSponsor(event) {
    const { sponsor, index } = event
    this.currentSponsorIndex = index
    this.resetEvent(this.inPersonEventSponsor);
    this.campaignService.initializeForm(this.inPersonEventSponsor, sponsor,  SponsorSchema);
    this.sponsorMode = 'editor';
    this.sponsorSubmitted = false;
  }

  onSaveSponsor() {
    this.sponsorSubmitted = true;

    if (this.inPersonEventSponsor.invalid || this.inPersonEventSponsor.get('imageUrl').value === '/images/blank_2x1.png') {
      this.inPersonEventSponsor.markAllAsTouched();
      return;
    }

    if (this.currentSponsorIndex || this.currentSponsorIndex === 0) {
      (this.form.get('sponsors') as UntypedFormArray).at(this.currentSponsorIndex).patchValue(this.inPersonEventSponsor.value);
      this.currentSponsorIndex = null;
    } else {
      const form = new UntypedFormGroup({});
      this.campaignService.generateForm(form, SponsorSchema);
      this.campaignService.initializeForm(form, this.inPersonEventSponsor.value, SponsorSchema);
      const sponsors = this.form.get('sponsors') as UntypedFormArray
      sponsors.push(form);
    }

    this.onChangeSponsorMode('list');
  }

  getSponsorImageErrorMessage() {
    if (this.sponsorSubmitted === false) {
      return;
    }

    if (this.inPersonEventSponsor.get('imageUrl').value === '/images/blank_2x1.png') {
      return 'Image cannot be empty';
    }

    return '';
  }

  resetVideoUrl() {
    this.videoContainerPart.get('videoContainerUrl').setValue('')
    this.videoContainerPart.get('videoContainerUrl').markAsUntouched();
  }

  onShowThemeConfiguration(status: boolean): void {
    this.themeConfigurationScreen = status;
  }
  onAfterCollapse(accorItem) {
    this.accordion[accorItem].expanded = false;
  }

  onAfterExpand(accorItem) {
    this.accordion[accorItem].expanded  = true;
  }

  getEditorInstance(quill,type){
    

    let tooltip = quill.theme.tooltip;
    let input = tooltip.root.querySelector("input[data-link]");
    let root = tooltip.root
    
    input.dataset.link = 'https://paybee.io';

    input.addEventListener('input',()=>{
      let error = root.querySelector(".quillError")
        if(error){
            error.remove()
            root.style.height = '40px'
        }
    })

    let errorSpan = document.createElement('span')
    errorSpan.className = 'quillError'
    errorSpan.textContent = 'Incorrect link. Use full url including https://.'

    quill.getModule('toolbar').addHandler('link', function() {
           tooltip.edit('link','')
        let error = root.querySelector(".quillError")
        if(error){
            error.remove()
            root.style.height = '40px'
        }
    });

    var tooltipSave = quill.theme.tooltip.save;
    quill.theme.tooltip.save = function() {
      var url = this.textbox.value;
      const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
      // validate url
      if(urlRegex.test(url)) {
          tooltipSave.call(this);
      }
      else {
        root.style.height = '60px'
        root.append(errorSpan)
      }
  };

      switch(type){
        case 'desc':
          this.quillInPersonEventInstanse = quill
          const deltaOne = quill.clipboard.convert(this.inPersonEventDescription.value)
          quill.setContents(deltaOne, 'silent')
          break;
        case 'textBlock':
            this.quillTextBlockInstanse = quill
            const deltaTwo = quill.clipboard.convert(this.textBlockDescription.value)
            quill.setContents(deltaTwo, 'silent')
            break;
        case 'videoContainerDesc':
              this.quillVideoDescInstanse = quill
              const deltaThree = quill.clipboard.convert(this.videoDescription.value)
              quill.setContents(deltaThree, 'silent')
              break;
        }
  }

  onEditorChanged(quill,type){

    if (this.inPersonEventSettedContent === true){
      this.inPersonEventSettedContent = false
      return
    }
    if (this.textBlockSettedContent === true){
      this.textBlockSettedContent = false
      return
    }
    if (this.videoSettedContent === true){
      this.videoSettedContent = false
      return
    }
        switch(type){
          case 'desc':
            let limit = 2048
            let quilLength = this.quillInPersonEventInstanse.getLength()
            this.quillDescLength = this.quillInPersonEventInstanse.getLength()
            const quillTextOne = this.quillInPersonEventInstanse.getText().trim()

            if (quilLength > limit) {
              this.quillInPersonEventInstanse.deleteText(limit, quilLength);
            }

            if(quillTextOne.length){
              this.inPersonEventDescription.setValue(this.quillInPersonEventInstanse.root.innerHTML)
            }else{
              this.inPersonEventDescription.setValue('')
            }

            if(quill.event == 'text-change'){
              let opsLength = quill.content.ops.length
              let oldOpsLength = quill.oldDelta.ops.length
              let content = quill.content.ops
              
              
              if(opsLength !== oldOpsLength){
                let cleanContent = this.quillService.formatText(content)
                this.inPersonEventSettedContent = true
                this.quillInPersonEventInstanse.setContents(cleanContent)
              }
            }
              break;
          case 'textBlock':
            let limitTwo = 1024
            let quilLengthTwo = this.quillTextBlockInstanse.getLength()
            this.quillTextBlockLength = this.quillTextBlockInstanse.getLength()
            const quillTextTwo = this.quillTextBlockInstanse.getText().trim()

            
            if (quilLengthTwo > limitTwo) {
              this.quillTextBlockInstanse.deleteText(limitTwo, quilLengthTwo);
            }

            if(quillTextTwo.length){
              this.textBlockDescription.setValue(this.quillTextBlockInstanse.root.innerHTML)
            }else{
              this.textBlockDescription.setValue('')
            }

            if(quill.event == 'text-change'){
              let opsLength = quill.content.ops.length
              let oldOpsLength = quill.oldDelta.ops.length
              let content = quill.content.ops
              
              
              if(opsLength !== oldOpsLength){
                let cleanContent = this.quillService.formatText(content)
                this.textBlockSettedContent = true
                this.quillTextBlockInstanse.setContents(cleanContent)
              }
            }
              break;
          case 'videoContainerDesc':
              let limitThree = 1024
              let quilLengthThree = this.quillVideoDescInstanse.getLength()
              this.quillVideoContainerDescLength = this.quillVideoDescInstanse.getLength()
              const quillTextThree = this.quillVideoDescInstanse.getText().trim()

              if (quilLengthThree > limitThree) {
                this.quillVideoDescInstanse.deleteText(limitThree, quilLengthThree);
              }

              if(quillTextThree.length){
                this.videoDescription.setValue(this.quillVideoDescInstanse.root.innerHTML)
              }else{
                this.videoDescription.setValue('')
              }
                if(quill.event == 'text-change'){
                  let opsLength = quill.content.ops.length
                  let oldOpsLength = quill.oldDelta.ops.length
                  let content = quill.content.ops
                  
                  
                  if(opsLength !== oldOpsLength){
                    let cleanContent = this.quillService.formatText(content)
                    this.videoSettedContent = true
                    this.quillVideoDescInstanse.setContents(cleanContent)
                  }
                }
                break;    
        }
  }

  uploadImages(id = 'slide-images') {
    if (!this.imagesQueue.length) {
      return;
    }

    return of.apply(null, this.imagesQueue).pipe(
      concatMap((image) => {
        return this.imageService.uploadImageByFileAndCrop(image['name'], image);
      })
    ).subscribe((response) => {
      if (response.imageUrl) {
        const form = new FormGroup({});
        this.campaignService.generateForm(form, SlideSchema);
        this.campaignService.initializeForm(form, {
          imageUrl: response.imageUrl,
          name: ""
        }, SlideSchema);
        const slides = this.slidesPart.get('slides') as FormArray;
        slides.push(form);
      }
    });
  }
}
